import React from 'react';
import {Button} from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import {BadgeWrapper, ButtonGroup, HeroDescription, HeroSection, HeroTitle, TrialNoteText,} from './styles';
import {useLandingContext} from "../../../Landing";

export default function Hero({onOpenTrial, onScrollToTariffs}) {
    const {APP_DATA} = useLandingContext();

    return (
        <HeroSection>
            <BadgeWrapper>
                <VerifiedIcon sx={{fontSize: 18}}/>
                {APP_DATA.description}
            </BadgeWrapper>
            <HeroTitle>{APP_DATA.heroTitle}</HeroTitle>
            <HeroDescription>{APP_DATA.heroDescription}</HeroDescription>
            <ButtonGroup>
                <Button
                    variant="contained"
                    size="large"
                    onClick={onOpenTrial}
                    style={{
                        borderRadius: 14,
                        padding: '12px 24px',
                        textTransform: 'none',
                        fontSize: '16px',
                        fontWeight: 700,
                        background: 'linear-gradient(135deg, #1976d2 0%, #115293 100%)',
                        boxShadow: '0 6px 20px rgba(25, 118, 210, 0.35)',
                    }}
                >
                    {APP_DATA.heroPrimaryCta}
                </Button>
                <Button
                    variant="outlined"
                    size="large"
                    onClick={onScrollToTariffs}
                    style={{
                        borderRadius: 14,
                        padding: '10px 24px',
                        textTransform: 'none',
                        fontSize: '15px',
                        fontWeight: 600,
                        borderColor: '#c5cae9',
                        color: '#1976d2',
                    }}
                >
                    {APP_DATA.heroSecondaryCta}
                </Button>
            </ButtonGroup>
            <TrialNoteText>{APP_DATA.heroTrialNote}</TrialNoteText>
        </HeroSection>
    );
}
